import { BaseReportHandler } from "./BaseReportHandler";
import { ExcelBuilder } from "../utils/ExcelBuilder";
import { PdfBuilder } from "../utils/PdfBuilder";
import { lang } from "../../../utils/langs";

export class FinancialReportHandler extends BaseReportHandler {
    
    getColumns() {
        return {
            headers: ['Código', 'Cuenta / Descripción', 'Saldo'],
            keys: ['codigo_cuenta', 'nombre', 'saldo_final']
        };
    }

    formatRow(item) {
        // Fallback for names in financial reports
        const name = item.auxiliar_name || item.account_name || item.auxiliary_name || item.description || item.nombre || '';
        const indentedName = item.level !== undefined ? " ".repeat(item.level) + name : name;
        return [item.codigo_cuenta, indentedName, item.saldo_final];
    }

    async downloadExcel() {
        const builder = new ExcelBuilder(this.metadata);
        builder.addMainHeader();

        const { headers } = this.getColumns();

        const renderSection = (section, level = 0) => {
            const sectionTitle = section.name || (section.codigo_cuenta ? `${section.codigo_cuenta} - ${section.nombre}` : "Sección");
            builder.addSectionTitle(sectionTitle, level);

            const rows = section.data || section.accounts || [];
            const dataRows = rows.map(item => this.formatRow(item));

            builder.addTable(headers, dataRows, {
                onRowAdded: (excelRow, values) => {
                    const rowIndex = dataRows.indexOf(values);
                    const item = rows[rowIndex];
                    
                    // Currency format for the last column
                    const lastCell = excelRow.getCell(3);
                    if (typeof lastCell.value === 'number') {
                        lastCell.numFmt = '"$"#,##0;[Red]"-"$#,##0';
                        lastCell.alignment = { horizontal: "right" };
                    }

                    if (item.level !== undefined && item.level <= 2) {
                        excelRow.eachCell(c => c.font = { bold: true });
                    }
                }
            });

            if (section.total !== undefined) {
                const totalValues = ["", "TOTAL " + lang('es', sectionTitle), section.total];
                builder.addTotalsRow(totalValues, [2]);
            }

            builder.addRow([]); // Spacer
            
            if (section.sub_sections) {
                section.sub_sections.forEach(sub => renderSection(sub, level + 1));
            }
        };

        this.sections.forEach(s => renderSection(s));

        await builder.download();
    }

    async downloadPdf(download = true) {
        const builder = new PdfBuilder(this.metadata);
        builder.addMainHeader();

        const { headers } = this.getColumns();

        const renderSectionPdf = (section) => {
            const sectionTitle = section.name || (section.account_code ? `${section.account_code} - ${section.account_name}` : "Sección");
            builder.addSectionHeader(sectionTitle);

            const rows = section.data || section.accounts || [];
            const bodyRows = rows.map(item => {
                const name = item.auxiliar_name || item.account_name || item.auxiliary_name || item.description || item.nombre || '';
                const val = item.saldo_final;
                
                return [
                    { text: item.codigo_cuenta },
                    { text: name, margin: [ (item.level || 0) * 5, 0, 0, 0] },
                    { text: builder.formatCurrency(val), alignment: "right", color: val < 0 ? 'red' : 'black' }
                ];
            });

            if (section.total !== undefined) {
                const totalValues = ["", "TOTAL " + lang('es', sectionTitle), section.total];
                bodyRows.push(builder.getTotalsRow(totalValues, [2]));
            }

            builder.addTable(headers, bodyRows, {
                widths: ['auto', '*', 'auto']
            });

            if (section.sub_sections) {
                section.sub_sections.forEach(sub => renderSectionPdf(sub));
            }
        };

        this.sections.forEach(s => renderSectionPdf(s));
        return builder.download(download);
    }
}
